<template>
  <Dialog v-model:visible="visible" header="Upload Images" :style="{ width: '50rem' }" modal>
    <FileUpload
      name="image[]"
      url="/api/images/upload"
      :multiple="true"
      accept="image/*"
      :maxFileSize="5000000"
      @error="onError"
    >
      <template #empty>
        <div class="flex flex-col items-center justify-center h-30">
          Drag and drop files to here to upload.
        </div>
      </template>
    </FileUpload>
  </Dialog>
</template>
<script setup lang="ts">
import Dialog from 'primevue/dialog';
import FileUpload from 'primevue/fileupload';
import { useToast } from 'primevue/usetoast';
import type { FileUploadErrorEvent } from 'primevue/fileupload';

const visible = defineModel<boolean>('visible', { required: true });
const toast = useToast();

function onError(event: FileUploadErrorEvent) {
  console.error('File upload error:', event);
  toast.add({
    severity: 'error',
    summary: 'Upload Failed',
    detail: 'Failed to upload. Please try again.',
    life: 5000,
  });
}
</script>
